<!-- 标签页 license by http://eleadmin.com -->
<template>
  <div class="ele-admin-tabs">
    <el-tabs :value="active" @tab-click="onTabClick" @tab-remove="onTabRemove">
      <el-tab-pane name="/" :label="homeTitle" />
      <el-tab-pane
        v-for="d in tabs"
        :key="d.key"
        :name="d.key"
        :label="d.title"
        :closable="d.closable"
      />
    </el-tabs>
    <el-dropdown class="ele-admin-tabs-drop" @command="onDropClick">
      <i class="el-icon-arrow-down"></i>
      <el-dropdown-menu slot="dropdown">
        <slot name="dropdown">
          <el-dropdown-item
            command="fullscreen"
            :icon="bodyFullscreen ? 'el-icon-_compress' : 'el-icon-full-screen'"
          >
            {{
              bodyFullscreen
                ? t('ele.tabs.fullscreenExit')
                : t('ele.tabs.fullscreen')
            }}
          </el-dropdown-item>
          <el-dropdown-item command="left" icon="el-icon-back">
            {{ t('ele.tabs.closeLeft') }}
          </el-dropdown-item>
          <el-dropdown-item command="right" icon="el-icon-right">
            {{ t('ele.tabs.closeRight') }}
          </el-dropdown-item>
          <el-dropdown-item command="other" icon="el-icon-close">
            {{ t('ele.tabs.closeOther') }}
          </el-dropdown-item>
          <el-dropdown-item command="all" icon="el-icon-circle-close">
            {{ t('ele.tabs.closeAll') }}
          </el-dropdown-item>
          <el-dropdown-item
            v-if="showRefresh"
            command="reload"
            icon="el-icon-refresh-right"
          >
            {{ t('ele.tabs.reload') }}
          </el-dropdown-item>
        </slot>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  import Locale from 'element-ui/lib/mixins/locale';

  export default {
    name: 'EleProTabs',
    mixins: [Locale],
    emits: [
      'tab-change',
      'tab-remove',
      'tab-remove-all',
      'tab-remove-left',
      'tab-remove-right',
      'tab-remove-other',
      'fullscreen-body',
      'reload-page'
    ],
    props: {
      // 标签页数据
      tabs: Array,
      // 页签选中
      active: String,
      // 主页标题
      homeTitle: String,
      // 右侧下拉是否显示刷新按钮
      showRefresh: Boolean,
      // 是否再次点击选中tab刷新
      clickReload: Boolean,
      // 内容区域是否处于全屏状态
      bodyFullscreen: Boolean
    },
    methods: {
      /* 处理tab点击 */
      onTabClick(obj) {
        if (this.active === obj.name) {
          if (this.clickReload) {
            this.reloadPage();
          }
          return;
        }
        let tab;
        for (let i = 0; i < this.tabs.length; i++) {
          if (this.tabs[i].key === obj.name) {
            tab = this.tabs[i];
            break;
          }
        }
        this.$emit('tab-change', tab ? tab : { key: obj.name });
      },
      /* 处理tab删除 */
      onTabRemove(name) {
        this.$emit('tab-remove', { name: name, active: this.active });
      },
      /* 下拉菜单点击 */
      onDropClick(command) {
        switch (command) {
          // 关闭左侧
          case 'left':
            this.$emit('tab-remove-left', this.active);
            break;
          // 关闭右侧
          case 'right':
            if (this.active === '/') {
              this.removeAllTab();
            } else {
              this.$emit('tab-remove-right', this.active);
            }
            break;
          // 关闭其他
          case 'other':
            this.$emit('tab-remove-other', this.active);
            break;
          // 关闭全部
          case 'all':
            this.removeAllTab();
            break;
          // 刷新当前
          case 'reload':
            this.reloadPage();
            break;
          // 内容全屏
          case 'fullscreen':
            this.$emit('fullscreen-body', !this.bodyFullscreen);
            break;
        }
      },
      /* 关闭全部Tab */
      removeAllTab() {
        this.$emit('tab-remove-all', this.active);
      },
      /* 刷新页面 */
      reloadPage() {
        this.$emit('reload-page');
      }
    }
  };
</script>
